import React, { useEffect, useRef } from 'react';

const SkillBG = () => {
  const bgRef = useRef(null);

  useEffect(() => {
    const updateMousePosition = (ev) => {
      if (!bgRef.current) return;

      const { clientX, clientY } = ev;
      const rect = bgRef.current.getBoundingClientRect();
      const offsetX = clientX - rect.left;
      const offsetY = clientY - rect.top;

      bgRef.current.style.setProperty('--x', `${offsetX}px`);
      bgRef.current.style.setProperty('--y', `${offsetY}px`);
    };

    window.addEventListener('mousemove', updateMousePosition);

    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
    };
  }, []);

  return <div ref={bgRef} className="background-gradient"></div>;
};

export default SkillBG;
